import { Button, Loading } from '@orobix/orobix-fe-components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { trainingWarningTreshold } from './const'
import { fetchCounter } from './utils'

const loadingIcon = <Loading />

type StartTrainingButtonProps = {
  isDisabled: boolean
  isLoading: boolean
  onSkipConfirmation: () => void
  onRequiresConfirmation: () => void
}

const StartTrainingButton = ({
  isDisabled,
  isLoading,
  onSkipConfirmation,
  onRequiresConfirmation,
}: StartTrainingButtonProps) => {
  const { t } = useTranslation()
  const [isFetching, setFetching] = useState(false)

  const handleClick = async () => {
    setFetching(true)
    const counter = await fetchCounter()
    setFetching(false)

    if (counter) {
      const usageOk =
        counter.currentValue / counter.threshold < trainingWarningTreshold
      const skipConfirmation = !counter.isEnabled || usageOk

      if (skipConfirmation) {
        onSkipConfirmation()
      } else {
        onRequiresConfirmation()
      }
    }
  }

  return (
    <div id="startTrainingButtonId">
      <Button
        label={t('Start a new training')}
        type="action"
        disabled={isDisabled || isFetching}
        onClick={(e) => {
          e.preventDefault()
          handleClick()
        }}
        icon={isLoading || isFetching ? loadingIcon : null}
      />
    </div>
  )
}

export default StartTrainingButton
